export default "__VITE_ASSET__kJJJ_NIN__"